import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, LoadingController, ModalController } from 'ionic-angular';

import { Reviews, Dokumen, assetDocuments, User } from '@providers/asset/';
import { FormDocumentsPage, DetailImagePage } from '../'

@Component({
  selector: 'page-asset-documents',
  templateUrl: 'page.html'
})
export class AssetDocumentsPage {

  akses:any={};
  data : any=[] ;
  asset_id='';
  asset_name='';
  asset_location_id='';
  asset_location_name='';
  loading:any;
  img_url='';

  doc_module : any;
  page_title : any; 
  
  constructor(
    public  navCtrl    : NavController,
    public  navParams  : NavParams,
    private toastCtrl  : ToastController,
    public  loadingCtrl: LoadingController,
    public  modalCtrl  : ModalController,
    public  userApi    : User,
    public  reviewApi  : Reviews,
    public  dokumenApi : Dokumen,
    public  assetDocumentsApi : assetDocuments
  ) {

    this.akses      = this.userApi.akses;
    this.doc_module = this.navParams.get('doc_module');
    if (this.doc_module=='doc'){
      this.page_title = 'Asset Documents';
    }else{
      this.page_title = 'Calibration Documents';
    }
    this.asset_id   = this.navParams.get('asset_id');
    this.asset_name = this.navParams.get('asset_name');
    this.asset_location_id   = this.navParams.get('location_id');
    this.asset_location_name = this.navParams.get('location_name');
    this.img_url    = this.dokumenApi.file_url;

    console.log("akses => ", this.akses);
    console.log('document modue => ', this.doc_module);
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  ionViewWillEnter(){
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  getList(){
    this.showLoading();
    let params = {
      asset_id : this.asset_id
    }
    let mod : any;
    if(this.doc_module == 'doc'){
      mod = this.assetDocumentsApi.get(params);
    }else{
      mod = this.assetDocumentsApi.getDocCalibration(params);
    }
    mod.subscribe((resp:any) => {
      this.data = resp.data;
      if(resp.data==''){
        this.presentToast('Asset ini belum memiliki data dokumen');
      }
      this.loading.dismiss();
    });
  }
  
  add() {
    this.navCtrl.push(FormDocumentsPage, {
      doc_module    :this.doc_module,
      asset_id      :this.asset_id,
      asset_name    :this.asset_name,
      location_id   :this.asset_location_id,
      location_name :this.asset_location_name
    });
  }

  detailImage(generated_name){
    let detailModal = this.modalCtrl.create(DetailImagePage, {
      url_image : this.img_url+generated_name,
      asset_document : true
    });
    detailModal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/asset/asset_documents/page.ts